import { IAttribute } from '../../base/annotation';
import { Metamodel } from 'app/model/base/model';
import { TabularCopySource } from 'app/model/pipeline/copysource/tabular-type.copysource';
import { DynamicsAXResourceDataset } from 'app/model/dataset/dynamics-ax-resource.dataset';

import { Constants } from 'app/shared/shared-constants';
import { adfModelTypeMap } from 'app/registries/consts/adf-model-type-map-const';

@Metamodel.model({
    name: adfModelTypeMap.dynamicsAX.copySourceType,
    display: [],
    tags: { datasetModel: Metamodel.modelFor(DynamicsAXResourceDataset) }
})
export class DynamicsAXCopySource extends TabularCopySource {
    public static readonly HTTP_REQUEST_TIMEOUT: IAttribute;

    @Metamodel.attribute({
        templatable: true,
        association: 'HTTP_REQUEST_TIMEOUT',
        display: `${stringResources.ModelName_Request_Timeout}`,
        constraint: {
            pattern: Constants.timeoutValidation
        }
    })
    public httpRequestTimeout?: string = '00:05:00';
}
